import React, { useEffect, useState } from 'react';
import './ManageEventPlan.scss';
import { InputLabel, InputType, SelectBorder } from '../../../Global/GlobalFormElement';
import axios from 'axios';
import { EXCHNAGE_UR_PAYMENTSL, EXCHNAGE_URL } from '../../../../Url/Url';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

export const ManageEventPlan = () => {
  const [activePlan, setActivePlan] = useState('free');
  const [paymentType, setPaymentType] = useState('');
  const [currencyType, setCurrencyType] = useState('');
  const [taxType, setTaxType] = useState('GST');
  const [vatPercentage, setVatPercentage] = useState('');
  const [gstPercentage, setGstPercentage] = useState('');
  const eventIdGet = useSelector((state) => state?.users?.id || "");
  const eventId = String(eventIdGet);
  const token = localStorage.getItem("token")
  const [percentage, setPercentage] = useState('');
  const [formData, setFormData] = useState({
    apiKey: '',
    secretKey: '',
    webhookKey: '',
  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePlanChange = (plan) => {
    setActivePlan(plan);
    if (plan === 'free') {
      setPaymentType('');
    }
  };

  const fetchPlanData = async () => {
    try {
      const response = await axios.get(`${EXCHNAGE_URL}/getpaymentlistbyeventid?eventId=${eventId}`, {
        headers: {
          "Content-Type": "aplication/json",
          authorization: `Bearer ${token}`,
        },
      });

      const data = response.data?.data?.[0];
      console.log(data, "data")
      if (data) {
        setActivePlan(data.status || 'free');
        setPaymentType(data.gateway_type || '');

        setFormData({
          apiKey: data.api_key || '',
          secretKey: data.api_secret || '',
          webhookKey: data.webhook || '',
        });
      }

      setTaxType(data.tax_type || "");
      setCurrencyType(data.currency_type || "");
      setVatPercentage(data.vat_percentage || "");
      setGstPercentage(data.gst_percentage || "");

    } catch (error) {
      console.error('Error fetching plan data:', error);
      toast.error('Failed to fetch plan data');
    }
  };

  useEffect(() => {
    fetchPlanData();
  }, []);


  const handleSubmit = async () => {
    if (activePlan === 'paid') {
      if (!paymentType) {
        toast.error('Please select a payment gateway type');
        return;
      }

      if (paymentType === 'stripe') {
        if (!formData.apiKey || !formData.secretKey || !formData.webhookKey) {
          toast.error('All Stripe fields are required');
          return;
        }
      }

      if (paymentType === 'razorpay') {
        if (!formData.apiKey || !formData.secretKey) {
          toast.error('All RazorPay fields are required');
          return;
        }
      }
    }

    let payload = { status: activePlan, eventid: eventId };

    if (activePlan === 'paid') {
      payload = {
        ...payload,
        eventid: eventId,
        gateway_type: paymentType,
        api_key: formData.apiKey || '',
        api_secret: formData.secretKey || '',
        webhook: formData.webhookKey || '',
        currency_type: currencyType,
        tax_type: taxType,
        vat_percentage: taxType === 'VAT' ? vatPercentage : null,
        gst_percentage: taxType === 'GST' ? gstPercentage : null,
      };
    }
    try {
      const response = await axios.post(`${EXCHNAGE_UR_PAYMENTSL}/save-payment-gateway`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      console.log('Submitted successfully:', response.data);
      toast.success('Plan submitted successfully!');
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Something went wrong!';
      console.error('Submission error:', error);
      toast.error(errorMessage);
    }
  };


  useEffect(() => {
    if (currencyType === 'INR' && taxType === 'GST') {
      setGstPercentage('18');
    }
  }, [currencyType, taxType]);
  return (
    <div className="event-plan-container">
      <div className="event-plan-card">
        <div className="text-center">
          <InputLabel>Choose Your Plan For This Event</InputLabel>
        </div>

        <div className="event-plan-toggle-buttons">
          <button
            className={`event-plan-toggle-button ${activePlan === 'free' ? 'event-plan-active-button' : ''}`}
            onClick={() => handlePlanChange('free')}
          >
            Free
          </button>

          <button
            className={`event-plan-toggle-button ${activePlan === 'paid' ? 'event-plan-active-button' : ''}`}
            onClick={() => handlePlanChange('paid')}
          >
            Paid
          </button>
        </div>

        {activePlan === 'free' ? (
          <div className="text-center">
            <p className="info-text">
              You have selected the <strong>Free</strong> plan.
            </p>
          </div>
        ) : (
          <>
            <div className="text-center">
              <p className="info-text">
                You have selected the <strong>Paid</strong> plan.
              </p>
            </div>
            <div className="paid-inputs">
              <div>
                <InputLabel>Select Payment Type</InputLabel>
                <SelectBorder
                  value={paymentType}
                  onChange={(e) => setPaymentType(e.target.value)}
                >
                  <option value="">Select Method</option>
                  <option value="stripe">Stripe</option>
                  <option value="razorpay">RazorPay</option>
                </SelectBorder>
              </div>

              {paymentType === 'stripe' && (
                <>
                  <div>
                    <InputLabel>
                      NOTE: Please add this webhook endpoint in your Stripe Account
                      https://api.awardsuite.in/api/payments/stripe-webhook
                    </InputLabel>
                  </div>
                  <div>
                    <InputLabel>
                      Stripe Publishable Key <span style={{ color: 'red' }}>*</span>
                    </InputLabel>
                    <InputType name="apiKey" type="text" placeholder="Enter Stripe publishable key" value={formData.apiKey || ""}
                      onChange={handleInputChange} />
                  </div>
                  <div>
                    <InputLabel>
                      Stripe Secret Key <span style={{ color: 'red' }}>*</span>
                    </InputLabel>
                    <InputType name="secretKey" type="text" placeholder="Enter Stripe secret key"
                      value={formData.secretKey || ""}
                      onChange={handleInputChange} />
                  </div>
                  <div>
                    <InputLabel>
                      Stripe Webhook Secret <span style={{ color: 'red' }}>*</span>
                    </InputLabel>
                    <InputType name="webhookKey" type="text" placeholder="Enter Stripe webhook secret"
                      value={formData.webhookKey || ""}
                      onChange={handleInputChange} />
                  </div>
                  <div>
                    <InputLabel>Currency Type <span style={{ color: 'red' }}>*</span></InputLabel>
                    <SelectBorder
                      value={currencyType}
                      onChange={(e) => setCurrencyType(e.target.value)}
                    >
                      <option value="">Select Currency</option>
                      <option value="INR">INR</option>
                      <option value="USD">USD</option>
                      <option value="AED">AED</option>
                    </SelectBorder>
                  </div>

                  <div>
                    <InputLabel>Tax Type <span style={{ color: 'red' }}>*</span></InputLabel>
                    <SelectBorder
                      value={taxType}
                      onChange={(e) => setTaxType(e.target.value)}
                    >
                      <option value="GST">GST</option>
                      <option value="VAT">VAT</option>
                    </SelectBorder>
                  </div>

                  {taxType === 'VAT' && (
                    <div>
                      <InputLabel>VAT Percentage <span style={{ color: 'red' }}>*</span></InputLabel>
                      <InputType
                        type="number"
                        min="0"
                        placeholder="Enter VAT % (e.g., 10)"
                        value={vatPercentage}
                        onChange={(e) => setVatPercentage(e.target.value)}
                      />
                    </div>
                  )}
                  {taxType === 'GST' && (
                    <div>
                      <InputLabel>GST Percentage *</InputLabel>
                      <InputType
                        type="number"
                        value={gstPercentage}
                        onChange={(e) => setGstPercentage(e.target.value)}
                      />
                    </div>
                  )}
                </>
              )}

              {paymentType === 'razorpay' && (
                <>
                  <div>
                    <InputLabel>
                      RazorPay Key ID <span style={{ color: 'red' }}>*</span>
                    </InputLabel>
                    <InputType
                      name="apiKey"
                      type="text"
                      placeholder="Enter RazorPay Key ID"
                      value={formData.apiKey || ""}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div>
                    <InputLabel>
                      RazorPay Secret <span style={{ color: 'red' }}>*</span>
                    </InputLabel>
                    <InputType
                      name="secretKey"
                      type="password"
                      placeholder="Enter RazorPay Secret"
                      value={formData.secretKey || ""}
                      onChange={handleInputChange}
                    />                 </div>
                  <div>
                    <InputLabel>Currency Type <span style={{ color: 'red' }}>*</span></InputLabel>
                    <SelectBorder
                      value={currencyType}
                      onChange={(e) => setCurrencyType(e.target.value)}
                    >
                      <option value="">Select Currency</option>
                      <option value="INR">INR</option>
                      <option value="USD" disabled={paymentType === 'razorpay'}>USD</option>
                      <option value="AED" disabled={paymentType === 'razorpay'}>AED</option>
                    </SelectBorder>
                  </div>

                  <div>
                    <InputLabel>Tax Type <span style={{ color: 'red' }}>*</span></InputLabel>
                    <SelectBorder
                      value={taxType}
                      onChange={(e) => setTaxType(e.target.value)}
                    >
                      <option value="GST">GST</option>
                      <option value="VAT">VAT</option>
                    </SelectBorder>
                  </div>

                  {taxType === 'VAT' && (
                    <div>
                      <InputLabel>VAT Percentage <span style={{ color: 'red' }}>*</span></InputLabel>
                      <InputType
                        type="number"
                        min="0"
                        placeholder="Enter VAT % (e.g., 10)"
                        value={vatPercentage}
                        onChange={(e) => setVatPercentage(e.target.value)}
                      />
                    </div>
                  )}
                  {taxType === 'GST' && (
                    <div>
                      <InputLabel>GST Percentage *</InputLabel>
                      <InputType
                        type="number"
                        value={gstPercentage}
                        onChange={(e) => setGstPercentage(e.target.value)}
                      />
                    </div>
                  )}

                </>
              )}



            </div>
          </>
        )}

        <div className="text-center mt-4">
          <button className="submit-event-plan-button" onClick={handleSubmit}>
            Submit Plan
          </button>
        </div>

      </div>
    </div>

  );
};
